import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WidgetFrame from '../../Utils/Widget/Frame/Frame.jsx';
import WidgetTitle, { ALIGN } from '../../Utils/Widget/Title/Title.jsx';
import PriceCheckInput from '../../PriceCheckInput/PriceCheckInput.jsx';
import { Desktop } from '../../Utils/MediaComponents/MediaComponents.tsx';
import realEstateTypes from '../../../realEstateTypes.js';
import { SUBTITLE_CONTENT, TITLE } from './content.js';
import { profileTypes } from '../../PriceCheckInput/stylingProfiles.js';
import {
  getRealEstateType,
  getPriceCheckInputs,
  isUserIntentAndHierarchyForNewDashboard,
} from '../../../selectors/selectors.js';
import actions from '../actions.js';
import priceCheckInputsConfig from '../../PriceCheckInput/inputsConfig.js';
import styles from './Widget.less';
import { RLE_BANNER_OLD, RLE_BANNER } from '../../../tracking/trackingNaming';
import LazyLoad from '../../Utils/LazyLoad/LazyLoad';

export const PriceCheckWidget = ({
  realEstateType,
  priceCheckInputs,
  updateInputs,
  userIntentAndHierarchyForNewDashboard,
}) => (
  <WidgetFrame>
    <div className={`grid grid-flex grid-justify-space-between ${styles.widgetContainer}`}>
      <div className="grid-item one-whole">
        <WidgetTitle
          id="price-check"
          useH3
          text={TITLE}
          subText={SUBTITLE_CONTENT}
          align={ALIGN.center}
          cosmaIcon="is24-icon-household-with-euro-sign"
        />
      </div>
      <Desktop
        render={() => (
          <div className="grid-item one-whole palm-hide lap-hide align-center grid-align-center">
            <LazyLoad height={110} id="price_check_oldwidget_lazyload">
              <img
                height="110"
                alt=""
                src="https://www.static-immobilienscout24.de/statpic/sales-journey/it/atlas/9f9f713e6e7f6d095c070763d2bc5776_Illustration_Functional_Black_House.png"
              />
            </LazyLoad>
          </div>
        )}
      />
      <PriceCheckInput
        realEstateType={realEstateType}
        stylingProfile={profileTypes.OVERVIEW_PAGE}
        priceCheckInputs={priceCheckInputs}
        updateInputs={updateInputs}
        reporting={{
          inputs: {
            [priceCheckInputsConfig.ZIP_CODE]: 'dashboard_price_appraisal_plz',
            [priceCheckInputsConfig.LIVING_AREA]: 'dashboard_price_appraisal_area',
            [priceCheckInputsConfig.PLOT_AREA]: 'dashboard_price_appraisal_plot_area',
            [priceCheckInputsConfig.ROOMS]: 'dashboard_price_appraisal_rooms',
          },
          button: [userIntentAndHierarchyForNewDashboard ? RLE_BANNER_OLD : RLE_BANNER],
        }}
      />
    </div>
  </WidgetFrame>
);

PriceCheckWidget.propTypes = {
  realEstateType: PropTypes.oneOf([
    realEstateTypes.HOUSE_BUY,
    realEstateTypes.APARTMENT_BUY,
    realEstateTypes.APARTMENT_RENT,
    realEstateTypes.HOUSE_RENT,
  ]).isRequired,
  priceCheckInputs: PropTypes.object.isRequired,
  updateInputs: PropTypes.func.isRequired,
  userIntentAndHierarchyForNewDashboard: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  realEstateType: getRealEstateType(state),
  priceCheckInputs: getPriceCheckInputs(state),
  userIntentAndHierarchyForNewDashboard: isUserIntentAndHierarchyForNewDashboard(state),
});

const mapDispatchToProps = {
  updateInputs: (key, value) => actions.priceCheckInputUpdate(key, value),
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceCheckWidget);
